/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type routes_Dashboard_QueryVariables = {};
export type routes_Dashboard_QueryResponse = {
    readonly viewer: {
        readonly isAnonymous: boolean | null;
        readonly isApprovedForAccess: boolean | null;
        readonly " $fragmentRefs": FragmentRefs<"Dashboard_viewer">;
    } | null;
};
export type routes_Dashboard_Query = {
    readonly response: routes_Dashboard_QueryResponse;
    readonly variables: routes_Dashboard_QueryVariables;
};



/*
query routes_Dashboard_Query {
  viewer {
    isAnonymous
    isApprovedForAccess
    ...Dashboard_viewer
    id
  }
}

fragment Dashboard_viewer on Viewer {
  id
  username
  isAnonymous
  ...ListSensorStreams_viewer
  ...ListHighPrioritySensorStreams_viewer
  ...ListViewerLabeledSensorStreams_viewer
}

fragment LabelingIssueListItem_issue on LabelingIssue {
  id
  description
  category
  status
  reporter {
    username
    id
  }
  labeler {
    username
    id
  }
  pallets {
    number
    id
  }
  boxes {
    number
    id
  }
  sensorStream {
    sensorName
    run {
      runName
      id
    }
    id
  }
  frame {
    indexInSensorStream
    id
  }
}

fragment ListHighPrioritySensorStreams_viewer on Viewer {
  id
  username
  isAnonymous
  isSupervisor
  highPrioritySensorStreams: sensorStreams(first: 15, labelingPriorities: [HIGH]) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        ...SensorStreamListItem_sensorStream
        __typename
      }
      cursor
    }
  }
}

fragment ListSensorStreams_viewer on Viewer {
  username
  isAnonymous
  isSupervisor
  allSensorStreams: sensorStreams(first: 20) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        ...SensorStreamListItem_sensorStream
        numFrames
        labelingPriority
        createTime
        updateTime
        run {
          id
          runName
          source
          createTime
          updateTime
          knownObjects
        }
        __typename
      }
      cursor
    }
  }
}

fragment ListViewerLabeledSensorStreams_viewer on Viewer {
  username
  isAnonymous
  isSupervisor
  viewerLabeledSensorStreams: sensorStreams(first: 15, onlyShowViewer: true) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        ...SensorStreamListItem_sensorStream
        numFrames
        labelingPriority
        createTime
        updateTime
        run {
          runName
          id
        }
        __typename
      }
      cursor
    }
  }
}

fragment SensorStreamListItem_sensorStream on SensorStream {
  id
  labelingDirections
  lightingConditions
  sensorName
  numFrames
  frameNumbers
  labelingPriority
  allowExport
  issues {
    ...LabelingIssueListItem_issue
    status
    id
  }
  run {
    runName
    source
    createTime
    updateTime
    id
  }
  labelSummary {
    labeledFrameCount
    viewerLabeledFrameCount
    labeledPocketCount
    labeledItemCount
    labeledPalletsAll {
      id
      objectType
      surfaceType
      author {
        id
        username
        shortName
      }
      frame {
        indexInSensorStream
        id
      }
    }
    labeledItemsAll {
      id
      objectType
      author {
        id
        username
        shortName
      }
      frame {
        indexInSensorStream
        id
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isAnonymous",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isApprovedForAccess",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "username",
  "args": null,
  "storageKey": null
},
v4 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "hasNextPage",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "endCursor",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pageInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "PageInfo",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v6/*: any*/)
  ]
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "labelingDirections",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "lightingConditions",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "sensorName",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "numFrames",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "frameNumbers",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "labelingPriority",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "allowExport",
  "args": null,
  "storageKey": null
},
v15 = [
  (v3/*: any*/),
  (v2/*: any*/)
],
v16 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "number",
    "args": null,
    "storageKey": null
  },
  (v2/*: any*/)
],
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "runName",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "frame",
  "storageKey": null,
  "args": null,
  "concreteType": "Frame",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "indexInSensorStream",
      "args": null,
      "storageKey": null
    },
    (v2/*: any*/)
  ]
},
v19 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "issues",
  "storageKey": null,
  "args": null,
  "concreteType": "LabelingIssue",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "description",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "category",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "status",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "reporter",
      "storageKey": null,
      "args": null,
      "concreteType": "LabelerUser",
      "plural": false,
      "selections": (v15/*: any*/)
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "labeler",
      "storageKey": null,
      "args": null,
      "concreteType": "LabelerUser",
      "plural": false,
      "selections": (v15/*: any*/)
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "pallets",
      "storageKey": null,
      "args": null,
      "concreteType": "LabeledPallet",
      "plural": true,
      "selections": (v16/*: any*/)
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "boxes",
      "storageKey": null,
      "args": null,
      "concreteType": "LabeledBox",
      "plural": true,
      "selections": (v16/*: any*/)
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "sensorStream",
      "storageKey": null,
      "args": null,
      "concreteType": "SensorStream",
      "plural": false,
      "selections": [
        (v10/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "run",
          "storageKey": null,
          "args": null,
          "concreteType": "Run",
          "plural": false,
          "selections": [
            (v17/*: any*/),
            (v2/*: any*/)
          ]
        },
        (v2/*: any*/)
      ]
    },
    (v18/*: any*/)
  ]
},
v20 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "source",
  "args": null,
  "storageKey": null
},
v21 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "createTime",
  "args": null,
  "storageKey": null
},
v22 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "updateTime",
  "args": null,
  "storageKey": null
},
v23 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "objectType",
  "args": null,
  "storageKey": null
},
v24 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "author",
  "storageKey": null,
  "args": null,
  "concreteType": "LabelerUser",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "shortName",
      "args": null,
      "storageKey": null
    }
  ]
},
v25 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "labelSummary",
  "storageKey": null,
  "args": null,
  "concreteType": "SensorStreamLabelSummary",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "labeledFrameCount",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "viewerLabeledFrameCount",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "labeledPocketCount",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "labeledItemCount",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "labeledPalletsAll",
      "storageKey": null,
      "args": null,
      "concreteType": "LabeledPallet",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        (v23/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "surfaceType",
          "args": null,
          "storageKey": null
        },
        (v24/*: any*/),
        (v18/*: any*/)
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "labeledItemsAll",
      "storageKey": null,
      "args": null,
      "concreteType": "LabeledItem",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        (v23/*: any*/),
        (v24/*: any*/),
        (v18/*: any*/)
      ]
    }
  ]
},
v26 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v27 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v28 = {
  "kind": "Literal",
  "name": "first",
  "value": 15
},
v29 = [
  (v28/*: any*/),
  {
    "kind": "Literal",
    "name": "labelingPriorities",
    "value": [
      "HIGH"
    ]
  }
],
v30 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "run",
  "storageKey": null,
  "args": null,
  "concreteType": "Run",
  "plural": false,
  "selections": [
    (v17/*: any*/),
    (v20/*: any*/),
    (v21/*: any*/),
    (v22/*: any*/),
    (v2/*: any*/)
  ]
},
v31 = [
  (v28/*: any*/),
  {
    "kind": "Literal",
    "name": "onlyShowViewer",
    "value": true
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "routes_Dashboard_Query",
    "type": "RootQuery",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "kind": "FragmentSpread",
            "name": "Dashboard_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "routes_Dashboard_Query",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "isSupervisor",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": "allSensorStreams",
            "name": "sensorStreams",
            "storageKey": "sensorStreams(first:20)",
            "args": (v4/*: any*/),
            "concreteType": "SensorStreamConnection",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "SensorStreamEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SensorStream",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v19/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "run",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Run",
                        "plural": false,
                        "selections": [
                          (v17/*: any*/),
                          (v20/*: any*/),
                          (v21/*: any*/),
                          (v22/*: any*/),
                          (v2/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "knownObjects",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      (v25/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v26/*: any*/)
                    ]
                  },
                  (v27/*: any*/)
                ]
              }
            ]
          },
          {
            "kind": "LinkedHandle",
            "alias": "allSensorStreams",
            "name": "sensorStreams",
            "args": (v4/*: any*/),
            "handle": "connection",
            "key": "ListSensorStreams_allSensorStreams",
            "filters": []
          },
          {
            "kind": "LinkedField",
            "alias": "highPrioritySensorStreams",
            "name": "sensorStreams",
            "storageKey": "sensorStreams(first:15,labelingPriorities:[\"HIGH\"])",
            "args": (v29/*: any*/),
            "concreteType": "SensorStreamConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "pageInfo",
                "storageKey": null,
                "args": null,
                "concreteType": "PageInfo",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v5/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "SensorStreamEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SensorStream",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v19/*: any*/),
                      (v30/*: any*/),
                      (v25/*: any*/),
                      (v26/*: any*/)
                    ]
                  },
                  (v27/*: any*/)
                ]
              }
            ]
          },
          {
            "kind": "LinkedHandle",
            "alias": "highPrioritySensorStreams",
            "name": "sensorStreams",
            "args": (v29/*: any*/),
            "handle": "connection",
            "key": "ListHighPrioritySensorStreams_highPrioritySensorStreams",
            "filters": []
          },
          {
            "kind": "LinkedField",
            "alias": "viewerLabeledSensorStreams",
            "name": "sensorStreams",
            "storageKey": "sensorStreams(first:15,onlyShowViewer:true)",
            "args": (v31/*: any*/),
            "concreteType": "SensorStreamConnection",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "SensorStreamEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SensorStream",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v19/*: any*/),
                      (v30/*: any*/),
                      (v25/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v26/*: any*/)
                    ]
                  },
                  (v27/*: any*/)
                ]
              }
            ]
          },
          {
            "kind": "LinkedHandle",
            "alias": "viewerLabeledSensorStreams",
            "name": "sensorStreams",
            "args": (v31/*: any*/),
            "handle": "connection",
            "key": "ListViewerLabeledSensorStreams_viewerLabeledSensorStreams",
            "filters": []
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "routes_Dashboard_Query",
    "id": null,
    "text": "query routes_Dashboard_Query {\n  viewer {\n    isAnonymous\n    isApprovedForAccess\n    ...Dashboard_viewer\n    id\n  }\n}\n\nfragment Dashboard_viewer on Viewer {\n  id\n  username\n  isAnonymous\n  ...ListSensorStreams_viewer\n  ...ListHighPrioritySensorStreams_viewer\n  ...ListViewerLabeledSensorStreams_viewer\n}\n\nfragment LabelingIssueListItem_issue on LabelingIssue {\n  id\n  description\n  category\n  status\n  reporter {\n    username\n    id\n  }\n  labeler {\n    username\n    id\n  }\n  pallets {\n    number\n    id\n  }\n  boxes {\n    number\n    id\n  }\n  sensorStream {\n    sensorName\n    run {\n      runName\n      id\n    }\n    id\n  }\n  frame {\n    indexInSensorStream\n    id\n  }\n}\n\nfragment ListHighPrioritySensorStreams_viewer on Viewer {\n  id\n  username\n  isAnonymous\n  isSupervisor\n  highPrioritySensorStreams: sensorStreams(first: 15, labelingPriorities: [HIGH]) {\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n    edges {\n      node {\n        id\n        ...SensorStreamListItem_sensorStream\n        __typename\n      }\n      cursor\n    }\n  }\n}\n\nfragment ListSensorStreams_viewer on Viewer {\n  username\n  isAnonymous\n  isSupervisor\n  allSensorStreams: sensorStreams(first: 20) {\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    edges {\n      node {\n        id\n        ...SensorStreamListItem_sensorStream\n        numFrames\n        labelingPriority\n        createTime\n        updateTime\n        run {\n          id\n          runName\n          source\n          createTime\n          updateTime\n          knownObjects\n        }\n        __typename\n      }\n      cursor\n    }\n  }\n}\n\nfragment ListViewerLabeledSensorStreams_viewer on Viewer {\n  username\n  isAnonymous\n  isSupervisor\n  viewerLabeledSensorStreams: sensorStreams(first: 15, onlyShowViewer: true) {\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    edges {\n      node {\n        id\n        ...SensorStreamListItem_sensorStream\n        numFrames\n        labelingPriority\n        createTime\n        updateTime\n        run {\n          runName\n          id\n        }\n        __typename\n      }\n      cursor\n    }\n  }\n}\n\nfragment SensorStreamListItem_sensorStream on SensorStream {\n  id\n  labelingDirections\n  lightingConditions\n  sensorName\n  numFrames\n  frameNumbers\n  labelingPriority\n  allowExport\n  issues {\n    ...LabelingIssueListItem_issue\n    status\n    id\n  }\n  run {\n    runName\n    source\n    createTime\n    updateTime\n    id\n  }\n  labelSummary {\n    labeledFrameCount\n    viewerLabeledFrameCount\n    labeledPocketCount\n    labeledItemCount\n    labeledPalletsAll {\n      id\n      objectType\n      surfaceType\n      author {\n        id\n        username\n        shortName\n      }\n      frame {\n        indexInSensorStream\n        id\n      }\n    }\n    labeledItemsAll {\n      id\n      objectType\n      author {\n        id\n        username\n        shortName\n      }\n      frame {\n        indexInSensorStream\n        id\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '4a9f90ce6a1b1ec0d54e5f00316b5afe';
export default node;
